import { render } from "./shippingDetails.vue?vue&type=template&id=469b18dc"
import script from "./shippingDetails.vue?vue&type=script&lang=js"
export * from "./shippingDetails.vue?vue&type=script&lang=js"

import "./shippingDetails.vue?vue&type=style&index=0&id=469b18dc&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__